import {
  FieldsEnum,
  FormsEnum,
  RenewalChangedAddressEnum,
} from 'app/shared/enums';
import { zipCodeChange } from 'app/services/businessFunctions/helpers/zipCodeChange';
import { showAddressFieldsForRenewal } from 'app/services/businessFunctions/helpers/showAddressFieldsForRenewal';

const firstCoownerAddressDetails = {
  checkoutCoowners1LegalAddressZipCodeChange(initialRun: boolean) {
    showAddressFieldsForRenewal(
      initialRun,
      RenewalChangedAddressEnum.Coowner1Legal
    );

    zipCodeChange(
      initialRun,
      FieldsEnum.Coowners1LegalAddressZipCode,
      FormsEnum.CheckoutForm
    );
  },
  checkoutCoowners1LegalAddressCityChange(initialRun: boolean) {
    showAddressFieldsForRenewal(
      initialRun,
      RenewalChangedAddressEnum.Coowner1Legal
    );
  },
  checkoutPaymentSuspendedCoowners1LegalAddressZipCodeChange(
    initialRun: boolean
  ) {
    zipCodeChange(
      initialRun,
      FieldsEnum.Coowners1LegalAddressZipCode,
      FormsEnum.CheckoutPaymentAlertForm
    );
  },
};

export default firstCoownerAddressDetails;
